<div
  class="prepaid-redeemed-success__overlay"
  *ngIf="isVisible"
  (click)="onOverlayClick($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title"
>
  <div class="prepaid-redeemed-success__container" (click)="$event.stopPropagation()">
    <header class="prepaid-redeemed-success__header">
      <h2 class="prepaid-redeemed-success__title">{{ title }}</h2>
      <button
        type="button"
        class="prepaid-redeemed-success__close"
        (click)="onClose()"
        aria-label="Close"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="#15172E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </header>

    <div class="prepaid-redeemed-success__body">
      <p class="prepaid-redeemed-success__note" *ngIf="note">{{ note }}</p>

      <div class="prepaid-redeemed-success__field prepaid-redeemed-success__field--full">
        <span class="prepaid-redeemed-success__label">Package</span>
        <span class="prepaid-redeemed-success__value">{{ data.packageLabel }}</span>
      </div>

      <div class="prepaid-redeemed-success__row">
        <div class="prepaid-redeemed-success__field">
          <span class="prepaid-redeemed-success__label">Wash Name</span>
          <span class="prepaid-redeemed-success__value">{{ data.washName }}</span>
        </div>
        <div class="prepaid-redeemed-success__field">
          <span class="prepaid-redeemed-success__label">Wash Type</span>
          <span class="prepaid-redeemed-success__value">{{ data.washType }}</span>
        </div>
      </div>

      <div class="prepaid-redeemed-success__row">
        <div class="prepaid-redeemed-success__field">
          <span class="prepaid-redeemed-success__label">Purchase Date</span>
          <span class="prepaid-redeemed-success__value">{{ data.purchaseDate }}</span>
        </div>
        <div class="prepaid-redeemed-success__field">
          <span class="prepaid-redeemed-success__label">Valid Till</span>
          <span class="prepaid-redeemed-success__value">{{ data.validTill }}</span>
        </div>
      </div>
    </div>

    <footer class="prepaid-redeemed-success__footer">
      <button type="button" class="prepaid-redeemed-success__got-it" (click)="onGotIt()">
        Got it
      </button>
    </footer>
  </div>
</div>
